<div class="body__holder">
    <lg-sidebar>
        <sidebar-dashboard
            id="dashboard"
            large="true"
            top="true"
            nameAlwaysVisible="true"
        ></sidebar-dashboard>

        <lg-sidebar-menu
            *lgSidebarPanel="
                let sidebar;
                id: 'menu';
                nameLc: 'APP._Sidebar.Menu';
                icon: 'icon-menu';
                top: true;
                nameAlwaysVisible: true
            "
            [sidebar]="sidebar"
        >
        </lg-sidebar-menu>

        <lg-sidebar-exports
            *lgSidebarPanel="
                let sidebar;
                id: 'export';
                nameLc: 'APP._Sidebar.Export';
                icon: 'icon-sidebar-export';
                top: true;
                nameAlwaysVisible: false
            "
            [sidebar]="sidebar"
        ></lg-sidebar-exports>

        <lg-sidebar-help
            *lgSidebarPanel="
                let sidebar;
                id: 'help';
                nameLc: 'APP._Sidebar.Help';
                icon: 'icon-sidebar-help';
                top: false
            "
            [supportLink]="'mailto:doelmatigheidsmonitor@logex.com'"
            [standardLinks]="helpLinks"
        >
            <ng-template let-version let-internal="internal" #version>
                <div class="lg-sidebar-help__bottom-group">
                    <div class="lg-sidebar-help__bottom-group__header">
                        {{ "APP._Topbar.Scenario" | lgTranslate }}
                    </div>
                    <div class="lg-sidebar-help__bottom-group__text">
                        {{ version.scenario_naam }}
                    </div>
                </div>
                <div class="lg-sidebar-help__bottom-group">
                    <div class="lg-sidebar-help__bottom-group__header">
                        {{ "APP._Topbar.Version_id" | lgTranslate }}
                    </div>
                    <div class="lg-sidebar-help__bottom-group__text">
                        {{ version.display_version_id }}
                    </div>
                    <div class="lg-sidebar-help__bottom-group__invisible" *ngIf="!internal">
                        System ID {{ version.id }}
                    </div>
                </div>
                <div class="lg-sidebar-help__bottom-group" *ngIf="internal">
                    <div class="lg-sidebar-help__bottom-group__header">System ID</div>
                    <div class="lg-sidebar-help__bottom-group__text">
                        {{ version.id }}&nbsp; {{ version.is_test ? "test" : "" }}&nbsp;&nbsp;({{
                            version.ziekenhuiscode
                        }})
                    </div>
                </div>
            </ng-template>
        </lg-sidebar-help>

        <lg-sidebar-account
            class="lg-sidebar-panel"
            *lgSidebarPanel="
                let sidebar;
                id: 'account';
                nameLc: 'APP._Sidebar.Account';
                icon: 'icon-account';
                top: false;
                badge: _userMessages
            "
        ></lg-sidebar-account>

        <lg-sidebar-settings
            *lgSidebarPanel="
                let sidebar;
                id: 'settings';
                nameLc: 'APP._Sidebar.Settings';
                icon: 'icon-settings';
                top: false
            "
            [sidebar]="sidebar"
        ></lg-sidebar-settings>

        <div *ngIf="_devMode">
            <lg-sidebar-dev-widget *lgSidebarWidget></lg-sidebar-dev-widget>
        </div>
    </lg-sidebar>

    <div class="body__content">
        <div class="breadcrumb-row">
            <div class="breadcrumb-row__split">
                <div class="breadcrumb-row__split__subrow-one">
                    <lg-breadcrumb titlePrefixLc="APP.ToolName" homeId="dashboard"></lg-breadcrumb>
                    <lg-sibling-placeholder
                        name="breadcrumb-row.left.second"
                    ></lg-sibling-placeholder>
                </div>
                <lg-breadcrumb-data-context
                    [showHospitalButton]="true"
                    [showScenarioButton]="_showScenarioButton"
                ></lg-breadcrumb-data-context>
            </div>
            <lg-sibling-placeholder name="breadcrumb-row.right"></lg-sibling-placeholder>
        </div>

        <router-outlet></router-outlet>
    </div>
    <lg-slideout width="360" variant="right" id="filters-right-slideout" #filterSlideout>
        <lg-filters-panel></lg-filters-panel>
    </lg-slideout>
</div>
